module.exports = __webpack_public_path__ + "img/cabecera.ad215ab1.jpeg";